import * as types from '../mutation-types'
import Http from 'utils/http'

export const all = ({ dispatch }) => {
	return Http.get(`sites`).then(response => {
		dispatch(types.SET_SITES, response.body.data);
	});
}

export const select = ({ dispatch }, site) => {
	dispatch(types.SET_SITE, site);

	localStorage.setItem('site', JSON.stringify(site));
}



// WEBPACK FOOTER //
// ./src/vuex/actions/sites.js